module.exports = __webpack_public_path__ + "img/maximize-icon.852c4aff.svg";